/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_TrackInputs */

const en_cp_form_track = /** @type {(inputs: Cp_Form_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track`)
};

const id_cp_form_track = /** @type {(inputs: Cp_Form_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalur`)
};

/**
* | output |
* | --- |
* | "Track" |
*
* @param {Cp_Form_TrackInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_track = /** @type {((inputs?: Cp_Form_TrackInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_TrackInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_track(inputs)
	return en_cp_form_track(inputs)
});